<div class="lum-c-dumb-filter">
  <a class="lum-c-dumb-filter__part" (click)="handleClickAttribute($event)">{{
    filter.attribute
  }}</a>
  <a class="lum-c-dumb-filter__part" (click)="handleClickPredicate($event)">{{
    filter.predicate
  }}</a>
  <a
    *ngIf="filter.values && filter.values.length > 0"
    class="lum-c-dumb-filter__part"
    (click)="handleClickValue($event)"
    >{{ filter.values.join(', ') }}</a
  >

  <button
    type="button"
    class="
      lum-button lum-button--link lum-button--small lum-c-dumb-filter__remove
    "
    title="Clear This Filter"
    aria-label="Clear This Filter"
    (click)="handleClickRemove($event)"
  >
    <i class="fas fa-times"></i>
  </button>
</div>
